/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Component } from '@angular/core';
import { BaseComponent } from '../../../../../../core/components';
import { NamespaceService } from '../../../../shared/services/utils';
import { UserService } from '../../../../../../core/services';

@Component({
    selector: 'app-list',
    templateUrl: './pipelines-list.component.html',
    styleUrls: ['./pipelines-list.component.scss']
})
export class PipelinesListComponent extends BaseComponent {
    /**
     * Table row data.
     */
    public tableRows = [];

    /**
     * Search term for searching the services table, also used with the search query parameter in the url.
     */
    public searchTerm: string | [] = '';

    /**
     * Store the user's ability to edit
     */
    public userCanEdit: boolean = false;

    /**
     * Namespace selected key.
     */
    public selectedNamespaceKey: string;

    constructor(
        private namespaceService: NamespaceService,
        private userService: UserService,
    ) {
        super();

        // TODO - do we need this, if we do we need to update the spec file - like the shuttle file.
        // this.selectedNamespaceKey = this.namespaceService.selectedNamespace.key;

        this.setUpUserValues();
        this.setUpPageData();
    }

    /**
     * Set up user values.
     * @private
     */
    private setUpUserValues(): void {
        const user = this.userService.getUser();
        this.userCanEdit = user.permissions && (user.permissions < 4 && user.permissions !== 0);
    }

    /**
     * Set up page data with API response.
     * @private
     */
    private setUpPageData(): void {
        // this.shuttleApiService.getShuttleList(this.selectedNamespaceKey)
        //     .pipe(takeUntil(this.destroyed$))
        //     .subscribe(data => {
        const data = [
            // {
            //     id: 1,
            //     label: 'dave',
            //     type: 'Backup',
            //     status: 'pending'
            // },
            // {
            //     id: 2,
            //     label: 'pipelines approved',
            //     type: 'updated',
            //     status: 'approved'
            // },
            // {
            //     id: 3,
            //     label: 'pipelines declined',
            //     type: 'updated',
            //     status: 'declined'
            // }
        ];
        this.populateTableRows(data);
        // });

    }

    /**
     * Populate table rows.
     * @param sidecars
     * @private
     */
    private populateTableRows(data): void {
        this.tableRows = [];
        if (data && data.length) {
            for (const item of data) {
                this.tableRows.push({
                    id: item.id,
                    label: item.label,
                    type: item.type,
                    status: item.status
                });
            }
        }
    }
}
